/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get supplier offer
 */
export const getSupplierOfferQueryIncludeDeletedDefault = false;

export const GetSupplierOfferQueryParams = zod.object({
  includeDeleted: zod.boolean().default(getSupplierOfferQueryIncludeDeletedDefault),
});

export const getSupplierOfferResponseTermsPriceOneCurrencyCodeMin = 3;
export const getSupplierOfferResponseTermsPriceOneCurrencyCodeMax = 3;

export const getSupplierOfferResponseTermsPriceOneCurrencyCodeRegExp = new RegExp("^[A-Z]{3}$");
export const getSupplierOfferResponseTermsPriceTwoAmountExclusiveMin = 0;

export const getSupplierOfferResponseTermsMinimumOrderQuantityExclusiveMin = 0;

export const getSupplierOfferResponseTermsOrderQuantityMultipleExclusiveMin = 0;

export const GetSupplierOfferResponse = zod.object({
  supplierId: zod.uuid().describe("Supplier identity."),
  catalogItemId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
  state: zod.enum(["ACTIVE", "DELETED"]),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  catalogItemKind: zod.enum(["MATERIAL", "SERVICE"]),
  eligibleForCatalogSupply: zod.boolean(),
  selectableForCustomerOffer: zod.boolean(),
  pricingStatus: zod.enum(["UNPRICED", "PRICED"]),
  terms: zod
    .object({
      price: zod
        .object({
          amount: zod.number(),
          currency: zod
            .object({
              code: zod
                .string()
                .min(getSupplierOfferResponseTermsPriceOneCurrencyCodeMin)
                .max(getSupplierOfferResponseTermsPriceOneCurrencyCodeMax)
                .regex(getSupplierOfferResponseTermsPriceOneCurrencyCodeRegExp),
            })
            .describe("ISO 4217 currency."),
        })
        .describe("Monetary amount whose scale respects its Currency minor-unit precision.")
        .and(
          zod.object({
            amount: zod.number().gt(getSupplierOfferResponseTermsPriceTwoAmountExclusiveMin),
          }),
        )
        .optional(),
      minimumOrderQuantity: zod
        .number()
        .gt(getSupplierOfferResponseTermsMinimumOrderQuantityExclusiveMin)
        .describe(
          "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
        ),
      orderQuantityMultiple: zod
        .number()
        .gt(getSupplierOfferResponseTermsOrderQuantityMultipleExclusiveMin)
        .describe(
          "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
        ),
    })
    .optional()
    .describe("Complete priced terms; protected price is omitted for an unauthorized reader."),
});

/**
 * @summary Update supplier offer
 */
export const updateSupplierOfferBodyPriceOneCurrencyCodeMin = 3;
export const updateSupplierOfferBodyPriceOneCurrencyCodeMax = 3;

export const updateSupplierOfferBodyPriceOneCurrencyCodeRegExp = new RegExp("^[A-Z]{3}$");
export const updateSupplierOfferBodyPriceTwoAmountExclusiveMin = 0;

export const updateSupplierOfferBodyMinimumOrderQuantityExclusiveMin = 0;

export const updateSupplierOfferBodyOrderQuantityMultipleExclusiveMin = 0;

export const UpdateSupplierOfferBody = zod.object({
  clearTerms: zod.boolean().optional(),
  price: zod
    .object({
      amount: zod.number(),
      currency: zod
        .object({
          code: zod
            .string()
            .min(updateSupplierOfferBodyPriceOneCurrencyCodeMin)
            .max(updateSupplierOfferBodyPriceOneCurrencyCodeMax)
            .regex(updateSupplierOfferBodyPriceOneCurrencyCodeRegExp),
        })
        .describe("ISO 4217 currency."),
    })
    .describe("Monetary amount whose scale respects its Currency minor-unit precision.")
    .and(
      zod.object({
        amount: zod.number().gt(updateSupplierOfferBodyPriceTwoAmountExclusiveMin),
      }),
    )
    .optional(),
  minimumOrderQuantity: zod
    .number()
    .gt(updateSupplierOfferBodyMinimumOrderQuantityExclusiveMin)
    .optional()
    .describe(
      "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
    ),
  orderQuantityMultiple: zod
    .number()
    .gt(updateSupplierOfferBodyOrderQuantityMultipleExclusiveMin)
    .optional()
    .describe(
      "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
    ),
});

export const UpdateSupplierOfferResponse = zod.void();

/**
 * @summary Delete supplier offer
 */
export const DeleteSupplierOfferResponse = zod.void();

/**
 * @summary List supplier offers
 */

export const listSupplierOffersQueryPerPageMax = 100;

export const listSupplierOffersQueryStateDefault = `ACTIVE`;
export const listSupplierOffersQuerySortKeyDefault = `supplierId`;

export const ListSupplierOffersQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listSupplierOffersQueryPerPageMax)
    .describe("Number of items per page"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listSupplierOffersQueryStateDefault)
    .describe("Supplier Offer state filter"),
  supplierId: zod.uuid().optional().describe("Supplier id filter"),
  catalogItemId: zod.uuid().optional().describe("Catalog Item id filter"),
  catalogItemKind: zod
    .enum(["MATERIAL", "SERVICE"])
    .optional()
    .describe("Immutable Catalog Item kind filter"),
  pricingStatus: zod
    .enum(["UNPRICED", "PRICED"])
    .optional()
    .describe("Supplier Offer pricing-status filter"),
  eligibleForCatalogSupply: zod.boolean().optional().describe("Catalog supply eligibility filter"),
  selectableForCustomerOffer: zod
    .boolean()
    .optional()
    .describe("Customer Offer source-selection eligibility filter"),
  sortKey: zod
    .enum(["supplierId", "catalogItemId"])
    .default(listSupplierOffersQuerySortKeyDefault)
    .describe("Supplier Offer sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
});

export const listSupplierOffersResponseItemsItemTermsPriceOneCurrencyCodeMin = 3;
export const listSupplierOffersResponseItemsItemTermsPriceOneCurrencyCodeMax = 3;

export const listSupplierOffersResponseItemsItemTermsPriceOneCurrencyCodeRegExp = new RegExp(
  "^[A-Z]{3}$",
);
export const listSupplierOffersResponseItemsItemTermsPriceTwoAmountExclusiveMin = 0;

export const listSupplierOffersResponseItemsItemTermsMinimumOrderQuantityExclusiveMin = 0;

export const listSupplierOffersResponseItemsItemTermsOrderQuantityMultipleExclusiveMin = 0;

export const listSupplierOffersResponseMetaTotalMin = 0;

export const ListSupplierOffersResponse = zod.object({
  items: zod.array(
    zod.object({
      supplierId: zod.uuid().describe("Supplier identity."),
      catalogItemId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
      state: zod.enum(["ACTIVE", "DELETED"]),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      deletedAt: zod.iso.datetime({offset: true}).nullable(),
      catalogItemKind: zod.enum(["MATERIAL", "SERVICE"]),
      eligibleForCatalogSupply: zod.boolean(),
      selectableForCustomerOffer: zod.boolean(),
      pricingStatus: zod.enum(["UNPRICED", "PRICED"]),
      terms: zod
        .object({
          price: zod
            .object({
              amount: zod.number(),
              currency: zod
                .object({
                  code: zod
                    .string()
                    .min(listSupplierOffersResponseItemsItemTermsPriceOneCurrencyCodeMin)
                    .max(listSupplierOffersResponseItemsItemTermsPriceOneCurrencyCodeMax)
                    .regex(listSupplierOffersResponseItemsItemTermsPriceOneCurrencyCodeRegExp),
                })
                .describe("ISO 4217 currency."),
            })
            .describe("Monetary amount whose scale respects its Currency minor-unit precision.")
            .and(
              zod.object({
                amount: zod
                  .number()
                  .gt(listSupplierOffersResponseItemsItemTermsPriceTwoAmountExclusiveMin),
              }),
            )
            .optional(),
          minimumOrderQuantity: zod
            .number()
            .gt(listSupplierOffersResponseItemsItemTermsMinimumOrderQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
          orderQuantityMultiple: zod
            .number()
            .gt(listSupplierOffersResponseItemsItemTermsOrderQuantityMultipleExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
        })
        .optional()
        .describe("Complete priced terms; protected price is omitted for an unauthorized reader."),
    }),
  ),
  meta: zod
    .object({
      total: zod
        .int()
        .min(listSupplierOffersResponseMetaTotalMin)
        .describe("Total matching items."),
      page: zod.int().min(1).describe("Current 1-indexed page."),
      perPage: zod.int().min(1).describe("Requested items per page."),
    })
    .describe("Metadata for a paginated collection."),
});

/**
 * @summary Create supplier offer
 */
export const createSupplierOfferBodyTermsPriceOneCurrencyCodeMin = 3;
export const createSupplierOfferBodyTermsPriceOneCurrencyCodeMax = 3;

export const createSupplierOfferBodyTermsPriceOneCurrencyCodeRegExp = new RegExp("^[A-Z]{3}$");
export const createSupplierOfferBodyTermsPriceTwoAmountExclusiveMin = 0;

export const createSupplierOfferBodyTermsMinimumOrderQuantityExclusiveMin = 0;

export const createSupplierOfferBodyTermsOrderQuantityMultipleExclusiveMin = 0;

export const CreateSupplierOfferBody = zod.object({
  supplierId: zod.uuid().describe("Supplier identity."),
  catalogItemId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
  terms: zod
    .object({
      price: zod
        .object({
          amount: zod.number(),
          currency: zod
            .object({
              code: zod
                .string()
                .min(createSupplierOfferBodyTermsPriceOneCurrencyCodeMin)
                .max(createSupplierOfferBodyTermsPriceOneCurrencyCodeMax)
                .regex(createSupplierOfferBodyTermsPriceOneCurrencyCodeRegExp),
            })
            .describe("ISO 4217 currency."),
        })
        .describe("Monetary amount whose scale respects its Currency minor-unit precision.")
        .and(
          zod.object({
            amount: zod.number().gt(createSupplierOfferBodyTermsPriceTwoAmountExclusiveMin),
          }),
        ),
      minimumOrderQuantity: zod
        .number()
        .gt(createSupplierOfferBodyTermsMinimumOrderQuantityExclusiveMin)
        .describe(
          "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
        ),
      orderQuantityMultiple: zod
        .number()
        .gt(createSupplierOfferBodyTermsOrderQuantityMultipleExclusiveMin)
        .describe(
          "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
        ),
    })
    .optional(),
});

export const CreateSupplierOfferResponse = zod.object({
  supplierId: zod.uuid().describe("Supplier identity."),
  catalogItemId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
});

/**
 * @summary Restore supplier offer
 */
export const RestoreSupplierOfferResponse = zod.void();
